export default "__VITE_ASSET__BLPPO6ml__"